module.exports = __webpack_public_path__ + "static/media/china.84911517.svg";